export const fetchPaymentsGatewayName = async ({
  accountID,
  shopID,
}: {
  accountID: string;
  shopID: string;
}): Promise<string> => {
  const res = await $.get(`/API/Account/${accountID}/Shop/${shopID}.json`);

  const { gatewayConfigID } = res.Shop;
  if (!gatewayConfigID) {
    return '';
  }

  const gwRes = await $.get(`/API/Account/${accountID}/GatewayConfig/${gatewayConfigID}.json`);
  const { gatewayID } = gwRes.GatewayConfig; // i.e.: "cayan" or "lightspeed-payments"
  return gatewayID;
};
